import { EventEmitter, Injectable } from '@angular/core';
import {
  APIRequestBodyModel,
  ClientProductRatePlanModel,
  ClientProductRoomModel,
  ContainerItemModel,
  ContainerItemOption,
  ContainerItemSelectedEntity,
  ContainerModel,
  LayoutModel,
} from '@app/models/server/layout.model';
import { ApiResponseBody } from '@app/models/client/new-request-body.model';
import { Observable, scan, startWith, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EventService {
  validateShortStayPackageEvent: EventEmitter<any> = new EventEmitter();
  continueBookingShortStayPackageEvent: EventEmitter<any> = new EventEmitter();
  destroyDetailPageComponents: EventEmitter<any> = new EventEmitter();
  destroyListPageComponents: EventEmitter<any> = new EventEmitter();
  selectRoomPopupEvent: EventEmitter<any> = new EventEmitter();

  selectedPaymentItem?: ContainerItemModel;
  selectedCouponContainer: ContainerModel;
  selectedCreditPointsContainer: ContainerModel;
  filterValueContainer: ContainerModel;

  userLoggedInEvent: EventEmitter<{
    authToken: string;
    fromState: string;
  }> = new EventEmitter();

  toggleFoodActionEvent: EventEmitter<{
    foodItem?: {
      selectedContainer: ContainerItemModel;
      isAdded: boolean;
    };
  }> = new EventEmitter();

  toggleRoomActionEvent: EventEmitter<{
    selectedRatePlans?: ClientProductRatePlanModel[];
    operationType?: string;
  }> = new EventEmitter();

  newActionApiEvent: EventEmitter<{
    selectedRatePlans?: ClientProductRatePlanModel[];
    operationType?: string;
    rewardData?: {
      coupon: string;
      enableRedeemCreditPoints: boolean;
      membershipBody: {
        isAdd: boolean;
        apiRequestBody: APIRequestBodyModel;
      };
    };
    createCheckoutData?: boolean;
    foodItem?: {
      selectedContainer: ContainerItemModel;
      isAdded: boolean;
    };
    resetData?: {
      nextAvailableDate?: ContainerItemOption;
      nextAvailableCheckinTime?: ContainerItemOption;
      nextAvailableHour?: ContainerItemOption;
    };
  }> = new EventEmitter();

  roomDataContainerUpdatedEvent: EventEmitter<{
    roomDataContainer?: ClientProductRoomModel[];
    operationType?: string;
  }> = new EventEmitter();

  /**
   * @DEPRECATED
   */
  actionApiEvent: EventEmitter<{
    containerItem: ContainerItemModel;
    isAdded: boolean;
    selectedEntities?: ContainerItemSelectedEntity[];
  }> = new EventEmitter();

  progressStepperEvent: EventEmitter<{ next: boolean; previous: boolean }> =
    new EventEmitter<{ next: boolean; previous: boolean }>();

  // feature list page event starts

  // Fire filterChangeEvent whenever user enters any input
  public filterChangeEvent: EventEmitter<{
    filterValues: { [key: string]: any };
  }> = new EventEmitter<{ filterValues: { [p: string]: any } }>();

  // Fire in mobile app only, whenever query is changed
  /**
   * @DEPRECATED
   */
  public queryChangeEvent: EventEmitter<{
    query: string;
  }> = new EventEmitter<{ query: string }>();
  public refreshListEvent: EventEmitter<any> = new EventEmitter<any>();
  public refresherChangeEvent: EventEmitter<any> = new EventEmitter<any>();

  public authModalChangeEvent: EventEmitter<any> = new EventEmitter<any>();

  // Fire in desktop app only, whenever query is changed
  /**
   * @DEPRECATED
   */
  public desktopQueryChangeEvent: EventEmitter<{
    responseBody: ApiResponseBody;
    resetProductId?: boolean;
    resetHeader?: boolean;
  }> = new EventEmitter<any>();

  // Fire in mobile only, whenever query is changed
  /**
   * @DEPRECATED
   */
  public mobileQueryChangeEvent: EventEmitter<{
    query: string;
    productId: string;
  }> = new EventEmitter<any>();

  // Fire in both apps, whenever user hits back button is changed
  public resetPageOnBackButtonEvent: EventEmitter<{
    query: string;
  }> = new EventEmitter<any>();

  // Fire final filter values with the child pages
  public finalFilterValuesChangeEvent: EventEmitter<{
    finalFilterValues: { [key: string]: any };
  }> = new EventEmitter<{ finalFilterValues: { [p: string]: any } }>();
  public clearAllFilterEvent: EventEmitter<{ onlyResetValues: boolean }> =
    new EventEmitter<{ onlyResetValues: boolean }>();

  public resetIndividualFilterEvent: EventEmitter<any> =
    new EventEmitter<any>();

  public selectMenuCategoryEvent: EventEmitter<{
    selectedTab: string;
  }> = new EventEmitter();

  public bookNowButtonClickEvent: EventEmitter<any> = new EventEmitter<any>();

  public openCartEvent: EventEmitter<any> = new EventEmitter<any>();

  public specialRequestedCommentEvent: EventEmitter<{ comment: string }> =
    new EventEmitter<{ comment: string }>();

  public scrollEvent: EventEmitter<any> = new EventEmitter<any>();

  public couponApplyEvent: EventEmitter<{
    layoutModel: LayoutModel;
  }> = new EventEmitter<{
    layoutModel: LayoutModel;
  }>();

  public creditPointApplyEvent: EventEmitter<{
    layoutModel: LayoutModel;
  }> = new EventEmitter<{
    layoutModel: LayoutModel;
  }>();

  public ngoApplyEvent: EventEmitter<{
    layoutModel: LayoutModel;
  }> = new EventEmitter<{
    layoutModel: LayoutModel;
  }>();

  public scrollToTopEvent: EventEmitter<any> = new EventEmitter<any>();

  public showPopoverEvent: EventEmitter<any> = new EventEmitter<any>();

  // feature list page event ends

  /*ionRefreshEvent: EventEmitter<{
    eventName: string;
  }> = new EventEmitter<any>();*/

  // openShortstaySearchPopupEvent: EventEmitter<any> = new EventEmitter();

  /**
   * @DEPRECATED
   */
  // public resetQueryStateEvent: EventEmitter<any> = new EventEmitter<any>();

  /**
   * @DEPRECATED
   */
  public checkoutPageLoadedEvent: EventEmitter<{ isCheckoutPage: boolean }> =
    new EventEmitter<any>();

  public loggedOutEvent: EventEmitter<any> = new EventEmitter<any>();

  /*public mobileAppQueryUpdateEvent: EventEmitter<{ query: string }> =
    new EventEmitter<any>();*/

  public searchQueryChangeEvent: EventEmitter<{
    queryParams: any;
    resetLayoutData?: boolean;
  }> = new EventEmitter<any>();

  searchQueryChangedOnDetailPageEvent: EventEmitter<{
    queryParams: any;
    resetLayoutData?: boolean;
  }> = new EventEmitter<any>();

  /*  public publishSeoQueryParamsEvent: EventEmitter<{
      queryParams: any;
    }> = new EventEmitter<{ queryParams: any }>();*/

  closeRoomGuestDropdownEvent: EventEmitter<{
    type: string;
    exceptId: number;
  }> = new EventEmitter();

  markerClickEvent: EventEmitter<{
    container: ContainerModel;
  }> = new EventEmitter();

  retrievePageEvent: EventEmitter<any> = new EventEmitter();

  showMenu$$: Subject<any> = new Subject();
  showMenu$: Observable<any> = this.showMenu$$.pipe(
    scan((state: boolean, current: number) => {
      return !state;
    }),
    startWith(false),
  );

  toggleMenu() {
    this.showMenu$$.next(true);
  }
}
